function AnimateSpin({ size }) {
  return (
    <img
      src="/images/loading.svg"
      className="overflow-visible"
      width={size || 20}
      height={size || 20}
      alt="Loading svg circle icon"
    />
  );
}

export default AnimateSpin;
